
import React, { useContext, useEffect, useMemo } from "react";
import { styled } from "@mui/material/styles";
import { SiteContext } from "./utils/SiteContext";
import { GetLoggedIn, GetCompanyDetails } from "./utils/AxiosUtils";

import LoginPage from "./pages/login/LoginPage";
import AlertBar from "./components/AlertBar";
import SideBar from "./site components/SideBar";

import InventoryPage from "./pages/inventory/InventoryPage";
import ManageUsersPage from "./pages/manage users/ManageUsersPage";
import { ManageUsersProvider } from "./pages/manage users/ManageUsersContext";
import AccountPage from "./pages/account/AccountPage";
import WorkOrdersPage from "./pages/work orders/WorkOrdersPage";
import MaintenancePage from "./pages/maintenance/MaintenancePage";
import ReroutePage from "./pages/maintenance/ReroutePage";
import ApiDocsPage from "./pages/api docs/ApiDocsPage.jsx";

const MainPage = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  padding: 0,
  margin: 0,
}));

// Reusable tab component resolver (DRY)
function useTabResolver() {
  // Return a function so you can pass tabVal dynamically
  const resolveTab = (tabVal) => {
    const name = tabVal?.page ?? "Inventory";
    const props = tabVal?.props;

    const map = {
      Inventory: <InventoryPage searchProp={props} />,
      Orders: <WorkOrdersPage searchProp={props} />,
      "Manage Users": (
        <ManageUsersProvider>
          <ManageUsersPage />
        </ManageUsersProvider>
      ),
      Account: <AccountPage />,
      "API Docs": <ApiDocsPage  />,
    };

    // default fallback
    return map[name] ?? <InventoryPage />;
  };

  return resolveTab;
}

export default function App() {
  const { userInfo, alert, tab, custCompany } = useContext(SiteContext);
  const [userInfoVal, setUserinfo] = userInfo;
  const [alertBar, setAlertBar] = alert;
  const [tabVal] = tab;
  const [, setCustCompany] = custCompany;

  const getTab = useTabResolver();

  // On initial mount, check if user is logged in
  useEffect(() => {
    GetLoggedIn(setUserinfo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Once logged in, fetch company details
  useEffect(() => {
    if (userInfoVal?.loggedIn) {
      GetCompanyDetails(setCustCompany);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfoVal?.loggedIn]);

  //FOR MAINTENANCE MODE, UNCOMMENT BELOW 
  // return <MaintenancePage onRetry={() => window.location.reload()} />;

  //FOR REROUTE, UNCOMMENT BELOW
  // return <ReroutePage onRetry={() => window.location.href = 'https://portal.wca.com'} />;

  if (!userInfoVal?.loggedIn) {
    return (
      <div className="App">
        <LoginPage />
        <div style={{ position: "fixed", bottom: 16, left: 16, right: 16, zIndex: 1300 }}>
          <AlertBar alertBar={alertBar} setAlertBar={setAlertBar} />
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <MainPage>
        <SideBar>{getTab(tabVal)}</SideBar>
      </MainPage>

      <div style={{ position: "fixed", bottom: 16, left: 16, right: 16, zIndex: 1300 }}>
        <AlertBar alertBar={alertBar} setAlertBar={setAlertBar} />
      </div>
    </div>
  );
}

